import {
  LocalHospital as LocalHospitalIcon,
  Business as BusinessIcon,
  Category as CategoryIcon,
  Person as PersonIcon,
  AdminPanelSettings as AdminIcon,
} from "@mui/icons-material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { ModernCard } from "./shared/ModernCard";
import { ModernInfoItem } from "./shared/ModernInfoItem";
import { ModernGridInfo } from "./shared/ModernGridInfo";

export const CardDadosPlanoModern = () => {
  const { valueContractInternal } = useContextContrato();

  if (!valueContractInternal) return null;

  return (
    <ModernCard title="Dados do Plano" icon={<LocalHospitalIcon />}>
      <ModernGridInfo columns={2}>
        <ModernInfoItem
          icon={<CategoryIcon />}
          label="Tipo de Contrato"
          value={valueContractInternal.tipo_contrato}
        />
        <ModernInfoItem
          icon={<LocalHospitalIcon />}
          label="Produto"
          value={valueContractInternal.name_modalidades}
        />
        <ModernInfoItem
          icon={<BusinessIcon />}
          label="Operadora"
          value={valueContractInternal.name_operadoras}
        />
        {valueContractInternal.code_administradoras && (
          <ModernInfoItem
            icon={<AdminIcon />}
            label="Administradora"
            value={valueContractInternal.name_administradoras}
          />
        )}
        <ModernInfoItem
          icon={<PersonIcon />}
          label="Corretor"
          value={valueContractInternal.nome_produtor}
          fullWidth
        />
      </ModernGridInfo>
    </ModernCard>
  );
};
